import { Box, Skeleton, List, ListItem, Divider, Paper } from '@mui/material';

/**
 * Skeleton loader for list views (team members, invitations, recent projects)
 *
 * @param {Object} props - Component props
 * @param {number} props.items - Number of skeleton items (default: 5)
 * @param {boolean} props.showAvatar - Whether to show avatar skeleton
 * @param {boolean} props.showSecondary - Whether to show secondary text
 * @param {boolean} props.inPaper - Whether to wrap in Paper component
 */
const ListSkeleton = ({
  items = 5,
  showAvatar = true,
  showSecondary = true,
  inPaper = true,
}) => {
  const content = (
    <List disablePadding>
      {Array.from({ length: items }).map((_, index) => (
        <Box key={index}>
          <ListItem sx={{ py: 1.5 }}>
            {showAvatar && (
              <Skeleton
                variant="circular"
                width={40}
                height={40}
                sx={{ mr: 2 }}
              />
            )}
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="70%" height={24} />
              {showSecondary && (
                <Skeleton variant="text" width="50%" height={18} />
              )}
            </Box>
            <Skeleton variant="rounded" width={80} height={32} />
          </ListItem>
          {index < items - 1 && <Divider />}
        </Box>
      ))}
    </List>
  );

  if (inPaper) {
    return (
      <Paper elevation={2} sx={{ p: 2 }}>
        {content}
      </Paper>
    );
  }

  return content;
};

export default ListSkeleton;
